/**
 * Constantes para los IDs de bloques del sistema
 * Estos IDs corresponden a los definidos en BloquesSeeder.php
 */
export const BLOQUES = {
  CREAR_USUARIO: 1,
  EDITAR_USUARIO: 2,
  CREAR_EVALUADO: 3,
  EDITAR_EVALUADO: 4,
  VER_EVALUACION: 5,
} as const;

/**
 * Nombres descriptivos de los bloques
 */
export const NOMBRES_BLOQUES = {
  [BLOQUES.CREAR_USUARIO]: 'Crear Usuario',
  [BLOQUES.EDITAR_USUARIO]: 'Editar Usuario',
  [BLOQUES.CREAR_EVALUADO]: 'Crear Evaluado',
  [BLOQUES.EDITAR_EVALUADO]: 'Editar Evaluado',
  [BLOQUES.VER_EVALUACION]: 'Ver Evaluación',
} as const;

/**
 * Tipo para los IDs de bloques válidos
 */
export type BloqueId = typeof BLOQUES[keyof typeof BLOQUES];
